import { render, staticRenderFns } from "./FormPhone.vue?vue&type=template&id=3b87cef1"
import script from "./FormPhone.vue?vue&type=script&lang=js"
export * from "./FormPhone.vue?vue&type=script&lang=js"
import style0 from "./FormPhone.vue?vue&type=style&index=0&id=3b87cef1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports